module.exports = __webpack_public_path__ + "img/Box.baa1019b.svg";